import { rgba } from "polished";
import { useParams } from "react-router";

import { CenterContent, Icon } from "shared/styles";
import { copy } from "shared/assets";
import { Spacer } from "shared/layout";
import { Button, Title } from "shared/components";
import { getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { useCompanyRoute } from "Bands/utils";

const { companyPaymentStatus: companyPaymentStatusCopy } = copy;

export const CompanyPaymentSuccess = () => {
  let { type } = useParams<{ type: "general" | "paymentInfo" }>();
  const { icon, iconColor } = getStatus(IStatus.success);
  const { pushRoute } = useCompanyRoute();

  const typeCopy =
    type && companyPaymentStatusCopy[type]
      ? companyPaymentStatusCopy[type]
      : companyPaymentStatusCopy.general;

  return (
    <CenterContent>
      <Spacer size="xl" align="center">
        <Icon
          isCircle
          backgroundColor={rgba(iconColor as string, 0.25)}
          as={icon}
          height="60px"
          width="60px"
          color={iconColor}
          padding="18px"
        />
        <Title asComponent="h2">{typeCopy.success}</Title>
        <Button
          onClick={() => pushRoute(BAND_PATHS.COMPANY_DASHBOARD)}
          data-testid="back_button"
        >
          {companyPaymentStatusCopy.button}
        </Button>
      </Spacer>
    </CenterContent>
  );
};
